import React from 'react';
import PropTypes from 'prop-types';
import { ZCDTable } from '@zencity/common-ui';

/**
 * Display the pin option data table without sentiment breakdown
 */
const PinOptionDataTable = (props) => {
  const { counts } = props;
  const columns = [
    { Header: 'Pin', accessor: 'label' },
    { Header: 'Count', accessor: 'count' },
    { Header: '%', accessor: 'percentage' },
  ];
  const total = counts.reduce((acc, count) => acc + count.subtotal, 0);
  const data = counts.map((count) => ({
    label: count.label,
    count: count.subtotal,
    percentage: ((count.subtotal / total) * 100).toFixed(2),
  }));

  return (
    <div className="pin-option-data-table">
      <ZCDTable columnArray={columns} tableData={data} />
    </div>
  );
};

PinOptionDataTable.propTypes = {
  counts: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      subtotal: PropTypes.number,
    })
  ).isRequired,
};

export default PinOptionDataTable;
